type InteractionCallback = () => void;

const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const;
const LISTENER_OPTIONS: AddEventListenerOptions = { capture: true, passive: true };

const pendingStarts = new Set<() => void>();
let hasInteracted = false;

const onInteraction = (event: Event): void => {
  if (!event.isTrusted) return;
  INTERACTION_EVENTS.forEach((name) => window.removeEventListener(name, onInteraction, LISTENER_OPTIONS));
  hasInteracted = true;
  pendingStarts.forEach((start) => start());
  pendingStarts.clear();
};

export function trackFirstInteraction(): void {
  INTERACTION_EVENTS.forEach((name) => window.addEventListener(name, onInteraction, LISTENER_OPTIONS));
}

export function afterFirstInteraction(callback: InteractionCallback, delayMs = 0): () => void {
  let timerId: number | undefined;
  const start = (): void => {
    timerId = window.setTimeout(callback, delayMs);
  };

  if (hasInteracted) {
    start();
  } else {
    pendingStarts.add(start);
  }

  return () => {
    pendingStarts.delete(start);
    window.clearTimeout(timerId);
  };
}
